import { Stack, Grid, Typography, Box } from '@mui/material';
import RowContainer from '../components/RowContainer';
import PlayCircleFilledWhiteOutlinedIcon from '@mui/icons-material/PlayCircleFilledWhiteOutlined';
import { ReactComponent as Youtube } from 'assets/youtube.svg';

const Contents1 = () => {
  const info = [
    'Voice recognition : 음성키보드 사용을 위한 최신 의료 AI 음성 인식 모델이 탑재되어 환자 진료, 결과 판독, 기타 문서 작성 등 다양한 의료진 업무에 활용 기대',
    'Simple User interface : 필요한 기능 중심으로 서비스를 구성하여 서비스 사용 고객의 진입 장벽을 낮추고 편의성 향상을 목표',
    'User customize : 긴 의료 용어를 간편 약어로 변환, 날짜 및 시간 표현 방식 / 문단모양 등 텍스트 입력과 관련한 사용자 입력 스타일 유지 가능',
    'Template : 서식지 입력이 많은 의료 환경을 고려해 특정 위치로 텍스트 입력이 가능하게 하여 차트 작성 편의성 제고',
  ];

  return (
    <>
      <RowContainer xs={12} sx={{ margin: '0px 0px -20px 30px' }}>
        <Stack direction="column" gap={2}>
          <Stack direction="column" gap={1}>
            <Box sx={{ display: 'flex' }}>
              <Typography sx={{ fontWeight: 500, fontSize: '12px' }}>
                1. VOICE EMR 이란?
              </Typography>
              <button
                style={{
                  border: 'none',
                  display: 'flex',
                  backgroundColor: 'white',
                  marginTop: '-3px',
                  cursor: 'pointer',
                }}
                onClick={() =>
                  window.open(
                    'https://youtu.be/4GhjH-tWSF4?si=a84huq_OB9M3mNYJ'
                  )
                }
              >
                <Youtube style={{ height: '20px', width: '20px' }} />
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: '12px',
                    marginTop: '2px',
                    marginLeft: '3px',
                    color: 'red',
                  }}
                >
                  관련 영상
                </Typography>
              </button>
            </Box>
            <Typography sx={{ fontWeight: 400, fontSize: '12px' }}>
              Voice EMR은 의료 용어에 특화된 딥러닝 기반 음성인식 모델을
              활용하여 환자를 쳐다보며 진료할 수 있도록 진료 환경을 개선하는
              혁신적인 솔루션으로, 이를 통해 더 이상 의무기록 작성을 위해
              타이핑할 필요가
              <br />
              없으며 환자 케어에 더 집중할 수 있게 되었습니다.
            </Typography>
          </Stack>

          <Grid>
            <Stack direction="column" gap={1}>
              <Box sx={{ display: 'flex' }}>
                <Typography sx={{ fontWeight: 500, fontSize: '12px' }}>
                  2. Voice EMR 특장점
                </Typography>
                <button
                  style={{
                    border: 'none',
                    display: 'flex',
                    backgroundColor: 'white',
                    marginTop: '-3px',
                    cursor: 'pointer',
                  }}
                  onClick={() =>
                    window.open('https://youtu.be/_x6QtVvgRh4?feature=shared')
                  }
                >
                  <Youtube style={{ height: '20px', width: '20px' }} />
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: '12px',
                      marginTop: '2px',
                      marginLeft: '3px',
                      color: 'red',
                    }}
                  >
                    관련 영상
                  </Typography>
                </button>
              </Box>
              <Typography sx={{ fontWeight: 400, fontSize: '12px' }}>
                1）VoiceEMR은 사용자 맞춤형 서비스를 제공합니다.
              </Typography>
            </Stack>
            {info.map(a => {
              return (
                <Grid item xs={11.5} sx={{ marginLeft: '15px' }}>
                  <Typography sx={{ fontSize: '12px', lineHeight: '15px' }}>
                    • {a}
                  </Typography>
                </Grid>
              );
            })}
            <Typography
              sx={{ fontWeight: 400, fontSize: '12px', marginTop: '8px' }}
            >
              2）EMR / OCS / PACS 등 원하는 곳 어디든 연동하지 않고 입력 가능한
              “음성 키보드” 로 의료진의 기록업무 강도 완화와 환자 진료 중심에
              업무 문화 구축 목표
            </Typography>
          </Grid>
        </Stack>
      </RowContainer>
    </>
  );
};

export default Contents1;
